import iconos from "../img/iconos.png"
import "./css/Services.css"

const Services = () => {
  return (
    <section className="servicios-section" id="Servicios">
      <div className="servicios-container">
        <div className="servicios-image">
          <img
            src={iconos || "/placeholder.svg"}
            alt="Proceso de servicios aduaneros y logística"
            className="servicios-img"
          />
        </div>
        
        {/* Botón de Cauca y Recauca movido desde contactos */}
        <div className="cauca-button-container" id="Somos2">
          <a
            href="https://portal.sat.gob.gt/portal/recursos-aduaneros/"
            target="_blank"
            rel="noopener noreferrer"
            className="cauca-header"
          >
            <h2>Cauca y Recauca</h2>
            <div className="download-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </section>
  )
}

export default Services
